import React from "react";
import { createRoot } from "react-dom/client"; // Importa createRoot da react-dom/client
import "./index.css"; // Importa il file CSS per lo stile globale
import App from "./App"; // Importa il componente principale App
import { UserProvider }  from "../src/Components/UserContext"

const root = createRoot(document.getElementById("root")); // Crea un root per l'applicazione
root.render(<UserProvider><App title="Titolo Personalizzato"/></UserProvider>); // Rende il componente App nel root